/* =============================================================================
   Thirsty Threads - Size Guide calculator
   Added 9 September 2026. Rev 2: men's, boys' and girls'.

   Powers the "Find your size in ten seconds" box at the top of the Size Guide.
   The shopper picks a range, types a waist measurement, chooses inches or cm,
   and we name the size and highlight the matching row in that range's table.

   Rev 2 fixes a real defect: the first version only ever read the men's table,
   so any waist under about 31 inches came back as "outside our size range" -
   which is every child we sell to.

   The size bands are NOT hardcoded here. Each table carries data-range and
   data-range-label, and each row carries data-w-lo / data-w-hi in centimetres.
   Re-grade a table and this follows automatically, with nothing to keep in sync.

   Rev 3 also drives the size-chart tabs. The three charts sit in one tabbed
   block near the top of the page instead of being strung down it, so a parent
   is never scrolling past the men's chart and a long explainer to reach the
   kids'. The calculator's range selector and the chart tabs are the SAME
   control - change one and the other follows.

   Degrades safely: if the markup is absent the script does nothing. The tab
   panels are all visible until this script marks the container as tabbed, so
   with JavaScript off every chart still renders, one after another.
   ============================================================================= */
(function () {
  var CM_PER_IN = 2.54;
  var MIN_CM = 40;   /* smaller than any child we sell to */
  var MAX_CM = 160;

  /* Closing line per range. Mirrors the fit guidance further down the page. */
  var ADVICE = {
    mens: 'Same waist sizing in both ranges \u2014 Endless Summer is the roomier cut through the leg.',
    boys: 'Between sizes or growing fast? Size up \u2014 there is room to grow built in.',
    girls: 'Between sizes or growing fast? Size up \u2014 there is room to grow built in.'
  };

  function isKids(key) { return key === 'boys' || key === 'girls'; }

  function init() {
    var box = document.querySelector('[data-ttsg-calc]');
    if (!box) return;

    var input = box.querySelector('[data-ttsg-input]');
    var result = box.querySelector('[data-ttsg-result]');
    var unitBtns = box.querySelectorAll('[data-ttsg-unit]');
    var rangeBtns = box.querySelectorAll('[data-ttsg-range]');
    if (!input || !result) return;

    /* Build a band list per range, straight from the tables on the page. */
    var ranges = {};
    Array.prototype.forEach.call(
      document.querySelectorAll('.tt-tbl[data-range]'),
      function (table) {
        var key = table.getAttribute('data-range');
        var bands = Array.prototype.map.call(
          table.querySelectorAll('tr[data-w-lo]'),
          function (row) {
            var chip = row.querySelector('.ttsg-chip');
            return {
              row: row,
              lo: parseFloat(row.getAttribute('data-w-lo')),
              hi: parseFloat(row.getAttribute('data-w-hi')),
              name: chip ? chip.textContent.trim() : ''
            };
          }
        );
        if (bands.length) {
          ranges[key] = {
            label: table.getAttribute('data-range-label') || '',
            bands: bands
          };
        }
      }
    );

    if (!ranges.mens) return;

    var unit = 'in';
    var range = 'mens';

    function clearRows() {
      Array.prototype.forEach.call(
        document.querySelectorAll('.tt-tbl tr.is-match'),
        function (r) { r.classList.remove('is-match'); }
      );
    }

    function say(html) { result.innerHTML = html; }

    function sizeLabel(current, band) {
      return current.label ? current.label + ' ' + band.name : band.name;
    }

    function update() {
      var raw = parseFloat(input.value);
      var current = ranges[range];
      clearRows();

      if (!current) {
        say('Enter a waist measurement and we’ll name the size.');
        return;
      }

      if (!input.value || isNaN(raw) || raw <= 0) {
        say('Enter a waist measurement and we’ll name the size.');
        return;
      }

      var cm = unit === 'in' ? raw * CM_PER_IN : raw;

      /* Catch the common slip of typing inches while cm is selected. */
      if (cm < MIN_CM || cm > MAX_CM) {
        say('That doesn’t look like a waist measurement — check you have the right unit selected.');
        return;
      }

      var bands = current.bands;
      var smallest = bands[0];
      var largest = bands[bands.length - 1];

      var hit = null;
      for (var i = 0; i < bands.length; i++) {
        if (cm >= bands[i].lo && cm < bands[i].hi) { hit = bands[i]; break; }
      }

      if (hit) {
        hit.row.classList.add('is-match');
        say('You are a <strong>' + sizeLabel(current, hit) + '</strong>. ' + ADVICE[range]);
        return;
      }

      if (cm < smallest.lo) {
        smallest.row.classList.add('is-match');
        say('That is smaller than our smallest ' + (current.label || '') +
            ' size — <strong>' + sizeLabel(current, smallest) +
            '</strong> is the closest, and the drawstring will take up the difference.');
        return;
      }

      /* Above the range. Boys' tops out at 14 and most lads move into Men's XS
         from there, so point them somewhere useful. Girls' has no adult step-up,
         so don't send her to the men's range. */
      largest.row.classList.add('is-match');
      if (range === 'boys') {
        say('That is above our Boys\u2019 range. <strong>' + sizeLabel(current, largest) +
            '</strong> is our largest \u2014 from here, most teens move into our ' +
            '<strong>Men\u2019s XS</strong>.');
      } else if (isKids(range)) {
        say('That is above our ' + (current.label || '') + ' range. <strong>' +
            sizeLabel(current, largest) + '</strong> is our largest \u2014 the drawstring ' +
            'will take up a little, but it will be a close fit.');
      } else {
        say('That is above our largest size. <strong>' + sizeLabel(current, largest) +
            '</strong> is the biggest we make.');
      }
    }

    input.addEventListener('input', update);

    Array.prototype.forEach.call(unitBtns, function (btn) {
      btn.addEventListener('click', function () {
        unit = btn.getAttribute('data-ttsg-unit');
        Array.prototype.forEach.call(unitBtns, function (b) {
          b.classList.toggle('is-on', b === btn);
        });
        update();
      });
    });

    /* ---- Size-chart tabs, kept in lockstep with the calculator ---- */
    var tabWrap = document.querySelector('[data-ttsg-tabs]');
    var tabBtns = tabWrap ? tabWrap.querySelectorAll('[data-ttsg-tab]') : [];
    var panels = tabWrap ? tabWrap.querySelectorAll('[data-ttsg-panel]') : [];

    /* Only hide panels once we know JS is running. */
    if (tabWrap && panels.length) tabWrap.classList.add('is-tabbed');

    function setRange(key, scrollToChart) {
      if (!ranges[key]) return;
      range = key;

      Array.prototype.forEach.call(rangeBtns, function (b) {
        b.classList.toggle('is-on', b.getAttribute('data-ttsg-range') === key);
      });

      Array.prototype.forEach.call(tabBtns, function (b) {
        var on = b.getAttribute('data-ttsg-tab') === key;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      Array.prototype.forEach.call(panels, function (p) {
        p.classList.toggle('is-on', p.getAttribute('data-ttsg-panel') === key);
      });

      if (scrollToChart && tabWrap && tabWrap.scrollIntoView) {
        tabWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      update();
    }

    Array.prototype.forEach.call(rangeBtns, function (btn) {
      btn.addEventListener('click', function () {
        setRange(btn.getAttribute('data-ttsg-range'), false);
      });
    });

    Array.prototype.forEach.call(tabBtns, function (btn) {
      btn.addEventListener('click', function () {
        setRange(btn.getAttribute('data-ttsg-tab'), false);
      });
    });

    /* A link to #boys or #girls should open that chart, not just jump to it. */
    function openFromHash() {
      var key = (window.location.hash || '').replace('#', '');
      if (ranges[key]) setRange(key, true);
    }
    window.addEventListener('hashchange', openFromHash);

    setRange('mens', false);
    openFromHash();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
